/* istanbul ignore file */
import styled from 'styled-components';

export const Main = styled.main.attrs({
  id: 'mainContent',
  'data-automation': 'PageContent',
})`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const Content = styled.section.attrs({
  'data-automation': 'PageContentInner',
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 32px 40px 36px 40px;
  background: white;
  width: 100%;
`;

export const ContentInner = styled.div`
  width: 100%;
  max-width: ${({ theme }) => `${theme.screenMd}px`};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
